import { IUploadQueueData } from "./hooks/useUploadQueue";

type Listener = () => void;

export type IMediaLibraryState = {
  uploadQueue?: IUploadQueueData;
  onAddMissingFiles?: (uploadId: string) => void;
  onGoToFile?: (assetId: string) => void;
};

const createStore = <T,>(initial: T) => {
  let state = initial;
  const listeners = new Set<Listener>();

  return {
    getState: () => state,

    setState: (partial: Partial<T>) => {
      state = { ...state, ...partial };
      listeners.forEach((l) => l());
    },

    subscribe: (listener: Listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export const mediaLibraryStore = createStore<IMediaLibraryState>({
  uploadQueue: undefined,
});

export const mediaLibraryActions = {
  registerAddMissingFilesCallback(fn: (uploadId: string) => void) {
    mediaLibraryStore.setState({ onAddMissingFiles: fn });
  },

  registerGoToFileCallback(fn: (assetId: string) => void) {
    mediaLibraryStore.setState({ onGoToFile: fn });
  },

  clearCallbacks() {
    mediaLibraryStore.setState({
      onAddMissingFiles: undefined,
      onGoToFile: undefined,
    });
  },
};